import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../../utils/store';
import { useEffect, useState, useRef } from 'react';
import HttpService from '../../../services/HttpService';
import Constants from '../../../utils/constants';
import FormFieldData from '../../../Models/FormFieldData';
import { Box, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import CommonForm from '../../../components/form/CommonForm';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import IdLabelData from '../../../Models/IdLabelData';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';
import LabourDocuments from './parts/LabourDocuments';
import ConfirmDialog from '../../../components/ConfirmDialog';
import {
  validateEmailField,
  validatePhoneField,
} from '../../../utils/errorsUtil';
import { useAlert } from '../../../components/alertContext';
const empTypeList = [
  { id: 'Casual', label: 'Casual' },
  { id: 'Contractor', label: 'Contractor' },
  { id: 'Full Time', label: 'Full Time' },
  { id: 'Part Time', label: 'Part Time' },
];
const LabourForm: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { getAdmin } = useStore();
  const { currentId } = useParams<{ currentId: any }>();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  type formData = {
    [k: string]: { required: boolean; value: string | null | number };
  };
  const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
  const [jobRoles, setJobRoles] = useState<IdLabelData[]>([]);
  const [contractorList, setContractorList] = useState<IdLabelData[]>([]);
  const [form, setForm] = useState<formData>({
    id: { required: false, value: null },
    firstName: { required: true, value: '' },
    lastName: { required: true, value: '' },
    email: { required: false, value: '' },
    phoneNumber: { required: false, value: '' },
    employeeType: { required: true, value: '' },
    contractorId: { required: false, value: 0 },
    jobRoleId: { required: true, value: '' },
    costPerHour: { required: true, value: '' },
  });
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState('1');
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };
  const handleRowClick = (record: any) => {
    // console.log(record);
    setCurrentRecord(record);
    setForm({
      id: { required: false, value: record.id },
      firstName: { required: true, value: record.firstName },
      lastName: { required: true, value: record.lastName },
      email: { required: true, value: record.email },
      phoneNumber: { required: true, value: record.phoneNumber },
      contractorId: { required: true, value: record.contractorId },
      employeeType: { required: true, value: record.employeeType },
      jobRoleId: { required: true, value: record.jobRoleId },
      costPerHour: { required: true, value: record.costPerHour },
    });
  };
  const fetchJobRoles = async () => {
    try {
      const statusList: any = await fetchBundle('fetchJobRoles');
      if (statusList) {
        setJobRoles([{ id: '', name: 'Select Role' }, ...statusList]);
      }
    } catch (error: any) {
      console.error(`GET Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchBundle = async (type: string) => {
    return new Promise(async (resolve, reject) => {
      try {
        const URL = `${Constants.apiURL}${Constants.refBundleURL}/${type}`;
        const response = await HttpService.get(
          URL,
          { headers: { Authorization: 'Bearer ' + getAdmin() } },
          { search: '', limit: -1, offset: 0 }
        );
        if (response.data) {
          resolve(response.data);
        } else {
          reject('Failed to Fetch List. Please try again.');
        }
        console.log('GET Response:', response);
      } catch (error) {
        reject('Failed to Find List. Please try again.');
        console.error('Error fetching data:', error);
      }
    });
  };
  const fetchContractors = async () => {
    try {
      const response = await HttpService.get(
        Constants.apiURL + Constants.contractorsURL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { search: '', limit: -1, offset: 0 }
      );
      if (response.success) {
        setContractorList([
          { id: 0, label: 'Select Contractor' }, // Default option
          ...response.data.paginateRecords.map((item: any) => ({
            id: item.id,
            label: item.name,
          })),
        ]);
      }

      console.log('GET Response:', response);
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };
  const fetchSingleRecord = async (id: string) => {
    try {
      const response = await HttpService.get(
        `${Constants.apiURL + Constants.labourURL}/${id}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        null
      );
      if (response.success) {
        handleRowClick(response.data);
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    }
  };

  const clearForm = () => {
    setForm({
      id: { required: false, value: null },
      firstName: { required: true, value: '' },
      lastName: { required: true, value: '' },
      email: { required: true, value: '' },
      phoneNumber: { required: true, value: '' },
      contractorId: { required: true, value: '' },
      employeeType: { required: true, value: '' },
      jobRoleId: { required: true, value: '' },
      costPerHour: { required: true, value: '' },
    });
    setCurrentRecord(null);
    setAlert({
      type: 'error',
      message: '',
      open: false,
    });
    navigate('/data-management/labour');
  };

  const handleSave = async () => {
    setLoading(true);
    const reqData: any = {
      firstName: form.firstName.value,
      lastName: form.lastName.value,

      employeeType: form.employeeType.value,
      contractorId: form.contractorId.value,
      jobRoleId: form.jobRoleId.value,
      costPerHour: form.costPerHour.value,
    };

    if (form.email.value) {
      reqData['email'] = form.email.value;
    }
    if (form.phoneNumber.value) {
      reqData['phoneNumber'] = form.phoneNumber.value;
    }
    const endpoint = `${Constants.apiURL + Constants.labourURL}`;
    let response: any;
    try {
      if (currentRecord) {
        reqData['id'] = form.id.value;
        response = await HttpService.put(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      } else {
        response = await HttpService.post(endpoint, reqData, {
          headers: { Authorization: `Bearer ${getAdmin()}` },
        });
      }

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`PATCH Error:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prevData) => ({
      ...prevData,
      [name]: { ...prevData[name], value: value },
    }));
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      loadDataList();
    }
  }, [currentId]);

  const loadDataList = async () => {
    setIsLoading(true);
    if (jobRoles.length === 0) await fetchJobRoles();

    if (contractorList.length === 0) await fetchContractors();
    if (currentId !== 'Add') {
      await fetchSingleRecord(currentId);
    }
    setIsLoading(false);
  };
  const handleConfirmDialog = async (type: string) => {
    if (type === 'Yes') {
      setConfirmDialogOpen(false);
      setConfirmDialogOpen(false);
      navigate(`/data-management/labour`);
      clearForm();
    } else {
      setConfirmDialogOpen(false);
      return false;
    }
  };
  const formFields: FormFieldData[] = [
    {
      name: 'firstName',
      label: 'First name',
      value: form.firstName.value,
      onChange: handleInputChange,
      isRequired: form.firstName.required,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'First Name is required' : null)],
    },
    {
      name: 'lastName',
      label: 'Last name',
      value: form.lastName.value,
      onChange: handleInputChange,
      isRequired: form.lastName.required,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Last name is required' : null)],
    },
    {
      name: 'email',
      label: 'Email',
      value: form.email.value,
      onChange: handleInputChange,
      isRequired: form.email.required,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (value ? validateEmailField(value) : null)],
    },
    {
      name: 'phoneNumber',
      label: 'Phone',
      value: form.phoneNumber.value,
      onChange: handleInputChange,
      isRequired: form.phoneNumber.required,
      size: 6,
      type: 'textfield',
      validationRules: [(value) => (value ? validatePhoneField(value) : null)],
    },

    {
      name: 'jobRoleId',
      label: 'Job Role',
      value: form.jobRoleId.value,
      onChange: handleInputChange,
      isRequired: form.jobRoleId.required,
      size: 6,
      options: jobRoles,
      type: 'selectField',
      validationRules: [(value) => (!value ? 'Job Role is required' : null)],
    },
    {
      name: 'costPerHour',
      label: 'Cost p/h $',
      value: form.costPerHour.value,
      onChange: handleInputChange,
      isRequired: form.costPerHour.required,
      size: 6,
      inputType: 'number',
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Cost Per Hour is required' : null),
      ],
    },
    {
      name: 'employeeType',
      label: 'Employee Type',
      value: form.employeeType.value,
      onChange: handleInputChange,
      isRequired: form.employeeType.required,
      size: 6,
      type: 'selectField',
      options: empTypeList,
      validationRules: [
        (value) => (!value ? 'Employee Type is required' : null),
      ],
    },
    {
      name: 'contractorId',
      label: 'Contractor',
      value: form.contractorId.value,
      onChange: handleInputChange,
      isRequired: form.contractorId.required,
      isHidden: form.employeeType.value !== 'Contractor',
      size: 6,
      options: contractorList,
      type: 'selectField',
    },
  ];

  return (
    <Stack>
      <Box sx={{ width: '100%', marginTop: '35px', marginBottom: '35px' }}>
        <Box
          onClick={() => setConfirmDialogOpen(true)}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
        >
          <Typography variant="h6">
            <UTurnLeftIcon
              style={{
                transform: 'rotate(90deg)',
                cursor: 'pointer',
                marginTop: '4px',
              }}
              onClick={() => {
                setConfirmDialogOpen(true);
              }}
            />
          </Typography>
          <Typography variant="h6">Back</Typography>
        </Box>
        <Paper
          elevation={3}
          sx={{
            backgroundColor: '#ffffff',
          }}
        >
          {isLoading && (
            <Box sx={{ width: '100%', mt: 3 }}>
              <LinearProgress />
            </Box>
          )}
          <Typography
            variant="h6"
            style={{ paddingLeft: '30px', paddingTop: '30px' }}
          >
            {currentId !== 'Add' ? 'Update Labour' : 'Add New Labour'}
          </Typography>

          <Box
            sx={{
              padding: '10px',
              paddingBottom: '100px',

              margin: '0 auto 35px auto',
            }}
          >
            <Tabs
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  color: '#000B29',
                },
                '& .Mui-selected': {
                  color: '#000B29',
                  borderBottom: '2px solid #000B29',
                  fontSize: '14px',
                },
              }}
              value={currentTab}
              onChange={handleTabChange}
            >
              <Tab value="1" label="Labour Details" wrapped />
              {currentId !== 'Add' && <Tab value="2" label="Documents" />}
            </Tabs>
            {currentTab === '1' && (
              <CommonForm
                singlePage={true}
                fields={formFields}
                onCancel={() => {}}
                formReset={clearForm}
                formTitle={''}
                isLoading={loading}
                isUpdate={currentId !== 'Add' ? true : false}
                onSave={handleSave}
                actionButtonPosition="bottom"
              />
            )}
            {currentTab === '2' && currentId !== 'Add' && (
              <Box>
                <LabourDocuments labourId={currentId}></LabourDocuments>
              </Box>
            )}
          </Box>
          <ConfirmDialog
            handleClose={handleConfirmDialog}
            message="Are you sure, you want to exit?"
            open={confirmDialogOpen}
          ></ConfirmDialog>
          <AlertMessageComponent
            type={alert.type}
            open={alert.open}
            handleClose={handleCloseAlert}
            message={alert.message}
          />
        </Paper>
      </Box>
    </Stack>
  );
};

export default LabourForm;
